import React from 'react';
import Link from 'next/link';

type SingleItemProps = {
  item: { label: string; path?: string };
  isActive?: boolean;
  onClick?: () => void;
};

export const SingleItem = ({
  item,
  isActive = false,
  onClick = () => {},
}: SingleItemProps) => {
  return (
    <Link
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      href={item.path || '#'}
      className={`xl-custom:text-base xl-custom:leading-normal whitespace-nowrap text-left text-sm leading-tight text-[#333333] ${isActive ? 'font-semibold' : 'font-medium'}`}
    >
      {item.label}
    </Link>
  );
};
